import { Component, OnInit } from '@angular/core';

import { AppConst } from '../../app-const';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-manual-user-dialog',
  templateUrl: './manual-user-dialog.component.html',
  styleUrls: ['./manual-user-dialog.component.css'],
  standalone: false,
})
export class ManualUserDialogComponent implements OnInit {

  readonly manualTopLink: string = AppConst.ROUTING_LINK_MANUAL_INDEX;
  readonly nameDialogLink: string = AppConst.ROUTING_LINK_MANUAL_NAME_DIALOG;

  currentLang: string = 'ja';

  constructor(
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
    this.currentLang = this.translate.currentLang;
  }

}
